// extracted by mini-css-extract-plugin
export default {"disabled":"_6WBVbGPeJZQbmXFRPhhzQF"};